import React from 'react';
import Layout from './shared/Layout';
import Hero from './hero/Hero';

const Home = () => {
    
    return (
        <>
            <Layout>
            <Hero/>
            </Layout>
        </>
    )
}

export default Home;